import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillYoutube,
  AiOutlineInstagram,
} from "react-icons/ai";

import { useEffect, useState } from "react";

import { WeeklyPage } from "../components/WeeklyPage";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const Page18 = ({ pageIndex, subIndex, registerPageIndex }: any) => {
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "SENTİMENT ALGO’YA NASIL ULAŞIRIM?");
  }, []);

  return (
    <WeeklyPage
      cropped
      pageId={`page-${pageIndex}-${subIndex}`}
      style={{ backgroundImage: "none", backgroundColor: "white" }}
    >
      <WeeklyHeader title="SENTİMENT ALGO’YA NASIL ULAŞIRIM?" />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 20,
          justifyContent: "center",
          marginTop: 20,
          padding: "0 20px",
          fontFamily: "Open Sans",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 15,
            width: "50%",
          }}
        >
          <div
            style={{
              width: "100%",
              paddingInline: "10px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "600",
                marginBottom: "10px",
                borderRadius: "2px",
                fontSize: "22px",
              }}
            >
              Panele kayıt için
            </div>

            <div style={{ color: "black", fontSize: 20, lineHeight: "30px" }}>
              <p>
                <a
                  style={{ color: "black", textDecoration: "underline" }}
                  href="https://app.sentimentalgo.com"
                  target="_blank"
                >
                  app.sentimentalgo.com
                </a>{" "}
                adresine gir, kayıt ol. Panele gir.
              </p>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              paddingInline: "10px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "600",
                marginBottom: "10px",
                borderRadius: "2px",
                fontSize: "22px",
              }}
            >
              Abonelikler için
            </div>

            <div style={{ color: "black", fontSize: 20, lineHeight: "30px" }}>
              <p>
                <a
                  style={{ color: "black", textDecoration: "underline" }}
                  href="https://sentimentalgo.com/getiriler"
                  target="_blank"
                >
                  sentimentalgo.com/getiriler
                </a>
              </p>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              paddingInline: "10px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "600",
                marginBottom: "10px",
                borderRadius: "2px",
                fontSize: "22px",
              }}
            >
              Tüm sorularınız için mail hesabımız
            </div>

            <div style={{ color: "black", fontSize: 20, lineHeight: "30px" }}>
              <p>
                <a
                  style={{ color: "black", textDecoration: "underline" }}
                  href="mailto:info@zephlex.com"
                  target="_blank"
                >
                  info@zephlex.com
                </a>
              </p>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              paddingInline: "10px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "600",
                marginBottom: "10px",
                borderRadius: "2px",
                fontSize: "22px",
              }}
            >
              Tüm sorularınız için Whatsapp destek hattımız
            </div>

            <div style={{ color: "black", fontSize: 20, lineHeight: "30px" }}>
              <p>
                <a
                  style={{ color: "black", textDecoration: "underline" }}
                  href="https://wa.me/905324996368"
                  target="_blank"
                >
                  0532 499 63 68
                </a>
              </p>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              paddingInline: "10px",
              fontWeight: "500",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "600",
                marginBottom: "10px",
                borderRadius: "2px",
                fontSize: "22px",
              }}
            >
              Sosyal Medya Hesaplarımız
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                color: "black",
                alignItems: "center",
                marginTop: 10,
              }}
            >
              <a
                href="https://www.instagram.com/sentimentalgo/"
                target="_blank"
                style={{ color: "black" }}
              >
                <AiOutlineInstagram size={36} />
              </a>

              <a
                href="https://www.facebook.com/algosentiment/"
                target="_blank"
                style={{ color: "black" }}
              >
                <AiFillFacebook size={36} />
              </a>

              <a
                href="https://x.com/algo_sentiment"
                target="_blank"
                style={{ color: "black" }}
              >
                <svg
                  viewBox="0 0 24 24"
                  width="32"
                  height="32"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>

              <a
                href="https://www.linkedin.com/company/zephlex/"
                target="_blank"
                style={{ color: "black" }}
              >
                <AiFillLinkedin size={36} />
              </a>

              <a
                href="https://www.youtube.com/@sentimentalgo
"
                target="_blank"
                style={{ color: "black" }}
              >
                <AiFillYoutube size={36} />
              </a>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 15,
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/images/globe.svg"
            alt="Globe"
            style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
          />
        </div>
      </div>
    </WeeklyPage>
  );
};
